import { __decorate } from "tslib";
import { Vue, Component, Mixins, Prop } from 'vue-property-decorator';
import { uiMapper } from '@/services/store/modules/ui/store';
import { dataMapper } from '@/services/store/modules/data/store';
import IconSvg from './IconSvg.vue';
import vCLickOutside from 'v-click-outside';
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(['formCallIsShown', 'breakpoint'])
    }
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(['videoLink', 'quiz']),
        ...dataMapper.mapGetters(['quizAnswer'])
    },
    methods: {
        ...dataMapper.mapMutations(['updateQuizField', 'clearQuiz'])
    }
});
let SelectApp = class SelectApp extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        this.selectIsShown = false;
    }
    get isGtLg() { return this.breakpoint === 'lg' || this.breakpoint === 'xl'; }
    get isLtMd() { return this.breakpoint === 'xs' || this.breakpoint === 'sm'; }
    updateValue(value) {
        this.$emit('updateValue', { vIndex: this.vIndex, value });
    }
    toggleSelect() {
        this.selectIsShown = !this.selectIsShown;
    }
    closeSelect() {
        this.selectIsShown = false;
    }
};
__decorate([
    Prop()
], SelectApp.prototype, "options", void 0);
__decorate([
    Prop()
], SelectApp.prototype, "activeValue", void 0);
__decorate([
    Prop()
], SelectApp.prototype, "vIndex", void 0);
SelectApp = __decorate([
    Component({
        directives: {
            clickOutside: vCLickOutside.directive
        },
        components: {
            IconSvg
        },
    })
], SelectApp);
export default SelectApp;
